import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { requestTempPresignedUrls, RequestTempPresignedUrlsRequest } from "@/api";

export function useRequestTempPresignedUrls() {
  return useMutation({
    mutationFn: async (request: RequestTempPresignedUrlsRequest) => {
      const result = await requestTempPresignedUrls(request);
      if (result.err) {
        console.error(result.val.devMessage);
        toast.error("Error al obtener los enlaces temporales para subir las imagenes", {
          description: result.val.message,
        });
        throw new Error(result.val.message);
      }
      return result.val;
    },
  });
}
